import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { AuthProvider } from './lib/auth';
import { ConfirmProvider } from './components/Dialog';
import { ToastProvider } from './components/Toast';
import './index.css';

// Restore the explicit theme choice before first paint so there is no flash.
try {
  const stored = localStorage.getItem('ff.theme');
  if (stored) document.documentElement.setAttribute('data-theme', stored);
} catch { /* private window */ }

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // A 401 means the session is gone; retrying just delays the redirect to sign-in.
      retry: (failureCount, error) =>
        failureCount < 2 && !(error instanceof Error && error.message.includes('401')),
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <ToastProvider>
            <ConfirmProvider>
              <App />
            </ConfirmProvider>
          </ToastProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
